import { Link } from "react-router-dom";
import AdityaBirla from "./img/partners/AdityaBirla.jpg";
import Bajaj1 from "./img/partners/Bajaj-allianz-general-insurance.webp";
import Bajaj2 from "./img/partners/bajaj-allianz-life-insurance-online.jpeg";
import BandhanLife from "./img/partners/BandhanLife.jpg";
import Cholamandalam from "./img/partners/Cholamandalam.jpg";
import Carehealthinsurance from "./img/partners/Carehealthinsurance.png";
import FutureGenerali from "./img/partners/FutureGenerali.png";
import GoDigit from "./img/partners/Go-Digit.png";
import hdfclife from "./img/partners/hdfc-life.jpg";
import ICICI_Lombard from "./img/partners/ICICI_Lombard.jpg";
import ICICI_Prudential from "./img/partners/ICICI_Prudential.jpg";
import IffcoTokio from "./img/partners/IffcoTokio.png";
import KotakGeneral from "./img/partners/KotakGeneral.jpg";
import Libertygeneral from "./img/partners/Libertygeneral.jpg";
import LIC from "./img/partners/LIC.jpg";
import Magma from "./img/partners/Magma.png";
import Manipal from "./img/partners/Manipal.png";
import MAxLife from "./img/partners/MAxLife.jpg";
import NationalInsuarnce from "./img/partners/NationalInsuarnce.jpg";
import NivaBupa from "./img/partners/NivaBupa.jpg";
import Oriental from "./img/partners/Oriental.png";
import raheja from "./img/partners/raheja.png";
import Reliance from "./img/partners/Reliance.jpg";
import Royal from "./img/partners/Royal.jpg";
import SBIG from "./img/partners/SBIG.png";
import Shriram from "./img/partners/Shriram.png";
import Star from "./img/partners/Star.png";
import TATAAIA from "./img/partners/TATAAIA.jpg";
import TataAIG from "./img/partners/TataAIG.png";
import NewIndia from "./img/partners/NewIndia.jpg";
import UnitedIndia from "./img/partners/UnitedIndia.jpg";
import UniversalSompo from "./img/partners/UniversalSompo.png";
import Zuno from "./img/partners/Zuno.jpg";

function Partners() {
  window.scrollTo(0, 0);
  return (
    <>
      <div
        className="container-fluid page-header py-5 mb-5 wow fadeIn"
        data-wow-delay="0.1s"
      >
        <div className="container py-5">
          <h1 className="display-4 animated slideInDown mb-4">Partners</h1>
          {/* <nav aria-label="breadcrumb animated slideInDown">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item"><a href="#">Pages</a></li>
            <li class="breadcrumb-item active" aria-current="page">About</li>
          </ol>
        </nav> */}
        </div>
      </div>

      {/* <!-- Service Start --> */}
      <div>
        <div>
          <div className="text-center mx-auto" style={{ maxWidth: "500px" }}>
            <h1 className="display-6 mb-5">Our Partners</h1>
            <p>
              We are proud to partner with the following leading insurance
              companies:
            </p>
          </div>
          <div  className="marquee-container overflow-hidden bg-light shadow-sm">
            <div  className="marquee-content d-flex align-items-center">
              <div  className="marquee-item mx-2">
                <img
                  src={AdityaBirla}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Bajaj1}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Bajaj2}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={BandhanLife}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Carehealthinsurance}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Cholamandalam}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={FutureGenerali}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={GoDigit}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={hdfclife}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={ICICI_Lombard}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={ICICI_Prudential}
                  alt="Image"
                   
                />
              </div>
            </div>
          </div>
          <div  className="marquee-container overflow-hidden bg-light shadow-sm">
            <div  className="marquee-content d-flex align-items-center">
              <div  className="marquee-item mx-2">
                <img
                  src={IffcoTokio}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={KotakGeneral}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Libertygeneral}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={LIC}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Magma}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Manipal}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={NationalInsuarnce}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={MAxLife}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={NivaBupa}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Oriental}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={raheja}
                  alt="Image"
                   
                />
              </div>
            </div>
          </div>

          <div  className="marquee-container overflow-hidden bg-light shadow-sm">
            <div  className="marquee-content d-flex align-items-center">
              <div  className="marquee-item mx-2">
                <img
                  src={Reliance}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Royal}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={SBIG}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Shriram}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Star}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={TataAIG}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={NewIndia}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={UnitedIndia}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={UniversalSompo}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={Zuno}
                  alt="Image"
                   
                />
              </div>
              <div  className="marquee-item mx-2">
                <img
                  src={TATAAIA}
                  alt="Image"
                   
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Service End --> */}
    </>
  );
}
export default Partners;
